import { createAsyncThunk } from '@reduxjs/toolkit';
import {
	getGuideTrace as getGuideTraceApi,
	getWarehouseResidueMovementList as getWarehouseResidueMovementListApi,
} from '../../helpers/residue/backend_helper';

export const fetchResidueTrace = createAsyncThunk(
	'residueTrace/fetchTrace',
	async ({ entityId, max_depth = 10, include_movements = true }) => {
		const params = { max_depth, include_movements };
		return getGuideTraceApi(entityId, params);
	}
);

export const fetchResidueMovements = createAsyncThunk(
	'residueTrace/fetchMovements',
	async ({ guide_id, guide_detail_id, warehouse_id, skip = 0, limit = 200 }) => {
		const params = { skip, limit };
		if (guide_id) params.guide_id = guide_id;
		if (guide_detail_id) params.guide_detail_id = guide_detail_id;
		if (warehouse_id) params.warehouse_id = warehouse_id;
		return getWarehouseResidueMovementListApi(params);
	}
);
